export const validateRequired = (value: any) => {
    return !(value === '' || typeof value === 'undefined' || value === null)
}

// Type validators

export const validateEmail = (value: any, options?: { required?: boolean, equals?: string }) => {
    if((!options || !options.required) && !validateRequired(value)) return true

    if(options) {
        if(options.required && !validateRequired(value)) return false
        if(options.equals && value !== options.equals) return false
    }

    return (/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i).test(value)
}

export const validateEqual = (value: any, options?: { required?: boolean, equals?: string }) => {
    if((!options || !options.required) && !validateRequired(value)) return true

    if(options) {
        if(options.required && !validateRequired(value)) return false
        if(options.equals && value !== options.equals) return false
    }

    return true
}

export const validateNumber = (value: any, options?: { required?: boolean, length?: number, min?: number, max?: number }) => {
    if((!options || !options.required) && !validateRequired(value)) return true
    if(typeof value !== 'number') return false
    
    if(options) {
        if(options.required && !validateRequired(value)) return false
        if(options.length && !validateLength(value, { length: options.length })) return false
        if(options.min && !validateMin(value, { min: options.min })) return false
        if(options.max && !validateMax(value, { max: options.max })) return false
    }
    
    return true
}

export const validateBoolean = (value: any, options?: { required?: boolean, equals?: boolean }) => {
    if((!options || !options.required) && !validateRequired(value)) return true
    if(typeof value !== 'boolean') return false

    if(options) {
        if(options.required && !validateRequired(value)) return false
        if(options.equals && value !== options.equals) return false
    }
    
    return true
}

export const validateArray = (value: any) => {
    return Array.isArray(value)
}

// Length validators

export const validateLength = (value: any, options: { length: number }) => {
    if(typeof value !== 'string' && typeof value !== 'number' && !validateArray(value)) {
        return false
    }

    return (typeof value === 'number' ? value : value.length) === options.length
}

export const validateMin = (value: any, options: { min: number }) => {
    if(typeof value !== 'string' && typeof value !== 'number' && !validateArray(value)) {
        return false
    }

    return (typeof value === 'number' ? value : value.length) >= options.min
}

export const validateMax = (value: any, options: { max: number }) => {
    if(typeof value !== 'string' && typeof value !== 'number' && !validateArray(value)) {
        return false
    }

    return (typeof value === 'number' ? value : value.length) <= options.max
}